import React from 'react';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function CookieConsent() {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowConsent(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowConsent(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowConsent(false);
  };

  const handleSettings = () => {
    alert('Le impostazioni dei cookie saranno disponibili a breve. Per ora, seleziona Accetta o Rifiuta.');
  };

  if (!showConsent) {
    return null;
  }

  return (
    <div className="cookie-consent">
      <div className="cookie-content">
        <div className="cookie-text">
          <p><strong>Questo sito utilizza i cookie</strong></p>
          <p>Utilizziamo i cookie per migliorare la tua esperienza di navigazione, fornire contenuti personalizzati e analizzare il nostro traffico. I cookie ci aiutano anche a capire come interagisci con il nostro sito.</p>
          <p>Per maggiori informazioni, consulta la nostra <Link to="/privacy-policy">Politica sulla Privacy</Link>.</p>
        </div>
        <div className="cookie-buttons">
          <button className="cookie-btn cookie-btn-accept" onClick={handleAccept}>
            Accetta Tutto
          </button>
          <button className="cookie-btn cookie-btn-decline" onClick={handleDecline}>
            Rifiuta
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;